import React from 'react';
import { IPostCategory, IPostModel } from '../../../models';
import PostHeader from '../post-header.component';
import PostTypeImage from './post-type-image';
import PostTypeVideo from './post-type-video';

// import { Post } from '../post.component';

const PostTypeShare = ({
  post,
  currentCategory,
}: {
  post?: IPostModel | null;
  currentCategory?: IPostCategory;
}) => {
  // Bài gốc đã hết công khai (xoá mềm/đổi trạng thái/đổi đối tượng xem) sau khi bị chia sẻ — BE trả về
  // null thay vì lộ lại nội dung cũ. Không render PostHeader/ảnh/video, chỉ hiện khung báo không khả dụng.
  if (!post) {
    return (
      <div className="mt-2 px-4 py-2 rounded-lg text-sm font-medium border1 border-slate-300 dark:bg-dark2">
        <p className="text-zinc-400 dark:text-zinc-500">Nội dung này hiện không khả dụng.</p>
      </div>
    );
  }

  const isPostImage = post?.postType === 'image';
  const isPostVideo = post?.postType === 'video';

  return (
    <div className="mt-2 px-4 py-2 rounded-lg text-sm font-medium border1 border-slate-300 dark:bg-dark2">
      <div className="flex gap-3">
        <PostHeader post={post} currentCategory={currentCategory} />
      </div>
      <p className="text-sm text-zinc-800 dark:text-zinc-50 my-2">{post?.content}</p>
      {(isPostImage || post?.postType === 'normal') && <PostTypeImage post={post} isShare />}
      {isPostVideo && <PostTypeVideo post={post} />}
    </div>
  );
};

export default PostTypeShare;
